export default (params) => ({
  trigger: {
    name: 'order_status_element.click_invite_to_pay',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'invite_to_pay',
      },
    },
  },
});
